// Días `Y-m-d` de Europe/Madrid, como los que usa el backend en los filtros y
// los KPIs de Viajes y gasto (Taxi / VTC).

export const MADRID_TIME_ZONE = 'Europe/Madrid';

/** Día `Y-m-d` de Madrid de un instante. */
export function madridDay(date: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: MADRID_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

/** Suma (o resta) días a un día `Y-m-d`. */
export function addDays(day: string, days: number): string {
  const d = new Date(`${day}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

/** Desfase de Madrid (minutos sobre UTC) en un instante. */
function madridOffsetMinutes(date: Date): number {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: MADRID_TIME_ZONE,
    hourCycle: 'h23',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).formatToParts(date);
  const get = (type: string) => Number(parts.find((p) => p.type === type)?.value);
  const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'));
  return Math.round((asUtc - date.getTime()) / 60000);
}

/**
 * «2026-11-10T20:30» en hora de Madrid (lo que da `app-bo-date-input` en modo
 * `datetime`) → ISO 8601 con su desfase («2026-11-10T20:30:00+01:00»), como
 * pide el backend. `null` si no trae fecha y hora.
 */
export function madridLocalToIso(local: string): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(local);
  if (!match) return null;
  const [, y, mo, d, h, mi] = match.map(Number);
  const wallAsUtc = Date.UTC(y, mo - 1, d, h, mi);
  // El desfase depende del instante: se mide en la hora supuesta y se corrige una vez.
  let offset = madridOffsetMinutes(new Date(wallAsUtc));
  offset = madridOffsetMinutes(new Date(wallAsUtc - offset * 60000));
  const sign = offset >= 0 ? '+' : '-';
  const abs = Math.abs(offset);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${local.slice(0, 16)}:00${sign}${pad(Math.floor(abs / 60))}:${pad(abs % 60)}`;
}
